import { Controller } from "@hotwired/stimulus"

const COOKIE_NAME = "theme"
const COOKIE_DOMAIN = (() => {
  const host = window.location.hostname
  // Share cookie across all subdomains in production
  const match = host.match(/openclaw\.kr$/)
  return match ? ".openclaw.kr" : null
})()

function getThemeCookie() {
  const match = document.cookie.match(/(?:^|; )theme=([^;]*)/)
  return match ? decodeURIComponent(match[1]) : null
}

function setThemeCookie(value) {
  const maxAge = 365 * 24 * 60 * 60
  let cookie = `${COOKIE_NAME}=${encodeURIComponent(value)}; max-age=${maxAge}; path=/; SameSite=Lax`
  if (COOKIE_DOMAIN) cookie += `; domain=${COOKIE_DOMAIN}`
  document.cookie = cookie
}

export default class extends Controller {
  connect() {
    this.applyTheme()
  }

  toggle() {
    const isDark = document.documentElement.classList.contains("dark")
    if (isDark) {
      document.documentElement.classList.remove("dark")
      document.documentElement.style.colorScheme = "light"
      setThemeCookie("light")
    } else {
      document.documentElement.classList.add("dark")
      document.documentElement.style.colorScheme = "dark"
      setThemeCookie("dark")
    }
  }

  applyTheme() {
    const saved = getThemeCookie() || localStorage.getItem("theme")
    if (saved === "dark" || (!saved && window.matchMedia("(prefers-color-scheme: dark)").matches)) {
      document.documentElement.classList.add("dark")
      document.documentElement.style.colorScheme = "dark"
    } else {
      document.documentElement.classList.remove("dark")
      document.documentElement.style.colorScheme = "light"
    }
  }
}
